import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden" data-testid="hero">
      <div className="grain absolute inset-0 pointer-events-none" aria-hidden />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-12 md:pt-20 pb-12 md:pb-16 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-center">
        <div className="md:col-span-6 order-2 md:order-1">
          <p className="label mb-6" data-testid="hero-eyebrow">
            Denver · Est. 2018 · Painter & Educator
          </p>
          <h1
            className="serif font-light leading-[0.95] tracking-[-0.02em] text-[clamp(2.75rem,7vw,5.75rem)]"
            data-testid="hero-headline"
          >
            Art rooted in
            <br />
            <span className="italic text-[hsl(var(--accent))]">
              Black experience.
            </span>
            <br />
            Made in Denver.
          </h1>
          <p
            className="mt-8 md:mt-10 text-base md:text-lg text-[hsl(var(--ink-soft))] leading-relaxed max-w-xl"
            data-testid="hero-subhead"
          >
            Figurative, Western, and contemporary paintings that celebrate
            identity, culture, and the untold stories of the American West.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <Link
              to="/work"
              className="inline-flex items-center gap-3 bg-foreground text-background px-6 py-4 text-xs uppercase tracking-[0.18em] hover:opacity-90 transition-opacity"
              data-testid="hero-cta-collection"
            >
              View the Collection
              <ArrowRight className="h-3.5 w-3.5" />
            </Link>
            <Link
              to="/commissions"
              className="inline-flex items-center gap-3 border border-foreground px-6 py-4 text-xs uppercase tracking-[0.18em] hover:bg-foreground hover:text-background transition-colors"
              data-testid="hero-cta-commission"
            >
              Commission a Piece
            </Link>
          </div>
        </div>

        <div className="md:col-span-6 order-1 md:order-2">
          <figure className="relative" data-testid="hero-image">
            <div className="aspect-[4/5] md:aspect-[5/6] overflow-hidden bg-[hsl(var(--surface))]">
              <img
                src="https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8e43o2fp_Pink%20Cowboy.jpg"
                alt="The Pink Cowboy — Joseph Graves Jr."
                className="art-img w-full h-full object-cover"
              />
            </div>
            <figcaption className="mt-3 flex items-baseline justify-between gap-4">
              <span className="serif italic text-lg">The Pink Cowboy</span>
              <span className="label">Acrylic · 48 × 48 in. · 2024</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
